import AppContext from 'app/appContext'
import { useContext } from 'react'

export const useAppContext = () => useContext(AppContext)
